import { render, staticRenderFns } from "./Project-item.vue?vue&type=template&id=3cddef2c&"
import script from "./Project-item.vue?vue&type=script&lang=ts&"
export * from "./Project-item.vue?vue&type=script&lang=ts&"
import style0 from "./Project-item.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports